import { Tag, TagStatus } from "@magnetic/tag";

import { BaseColumnConfig } from "./baseColumnConfig";

const methodStatus = (method: string): TagStatus => {
  switch (method.toUpperCase()) {
    case "GET":
      return "info";
    case "POST":
      return "positive";
    case "PUT":
    case "PATCH":
      return "warning";
    case "DELETE":
      return "negative";
    default:
      return "inactive";
  }
};

export class HttpMethodColumn extends BaseColumnConfig<string> {
  compare(a: string = "", b: string = "") {
    return a.localeCompare(b);
  }
  render(value: string = "") {
    return <Tag.Status status={methodStatus(value)}>{value}</Tag.Status>;
  }
}
